<template>
  <div class="trList full-height linear-main3">
    <ld-header
      class="font-lg"
      transparent
      white
    >
      {{ trSearchInfo.fromStation }} ⇀ {{ trSearchInfo.toStation }}
      <span class="font12">{{ $t('E017','共') }}{{ trSearchInfo.trainList.length }}个车次</span>
    </ld-header>

    <!-- 日期选择栏 -->
    <list-date
      :date-info="dateInfo"
      @prevDay="prevDay"
      @toggle="showDate"
      @afterDay="afterDay"
    />
    <!--  -->
    <travel-tips
      v-if="trSearchInfo.fromStationCityId"
      :arrive-cityid="trSearchInfo.toStationCityId"
      :depport-cityid="trSearchInfo.fromStationCityId"
      :auto-popup="false"
      cplx="10904"
      @close="closeTravelTips"
      ref="traveltips"
    />



    <!-- 火车票列表组件 -->
    <train-common
      :list="trSearchInfo.trainList"
      @selected="selected"
    />
    <ld-call-service
      v-if="
        loginConfig &&
          loginConfig.pageName &&
          loginConfig.pageName.indexOf('柒个贰') > -1
      "
      from = "10904"
    />

    <!-- 日历 -->
    <ld-calendar
      ref="date"
      @selected="getDate"
      :mi0="than15"
    />
  </div>

</template>

<script>
/**
 * @copyright (C), 2018-2019
 * @file 火车票列表页面
 * @desc 火车票列表的查询参数来源只在 store 中的 tr/trSearchInfo 中获取
 * @param {Object} trSearchInfo 查询信息对象
 * ————> @param {String} fromStation 出发城市名称
 * ————> @param {String} toStation   到达城市名称
 * ————> @param {String} fromStationCode 出发城市三字码
 * ————> @param {String} toStationCode 到达城市三字码
 * ————> @param {String | Date} byTrainDate 出发日期 (yyyy-mm-dd | yyyy,mm,dd)
 * ————> @param {String} minRank 差标等级
 */

import { Switch } from 'vant'
import { mapGetters } from 'vuex'
import TrainCommon from './TrainCommon'
import { formatDate } from 'Utils/dateUtil'
import listDate from 'Components/tk/listDate'
import travelTips from 'Components/travelTips'
import ldCallService from 'Components/ldCallService'

import TrainBookInteractor from 'Domain/use-cases/train-book-interactor'
import {localget} from "Utils/storage";

export default {
  name: 'TrList',
  components: {
    [Switch.name]: Switch,
    TrainCommon,
    ldCalendar: () => import('Common/ldCalendar'),
    listDate,
    travelTips,
    ldCallService,

  },
  data() {
    return {
      checked: false,
      dateInfo: {},
      trainInfo:{}
    }
  },
  created() {
    this.dateInfo = formatDate(this.trSearchInfo.byTrainDate || new Date())
    this.getList()
  },
  methods: {
    async getList() {
      try {
        await this.handleGtParam()
        const {
          trainList,
          feeList,
          supplierCode,
          supplierId,
          supplierName,
          sellServiceCharge,
          offline_sellServiceCharge,
          tgOffline_sellServiceCharge,
          slp_sellServiceCharge
        } = await TrainBookInteractor.getTrainList(this.trSearchInfo)

        this.trSearchInfo.trainList = trainList
        this.trSearchInfo.feeList = feeList
        this.trSearchInfo.supplierCode = supplierCode
        this.trSearchInfo.supplierId = supplierId
        this.trSearchInfo.supplierName = supplierName
        this.trSearchInfo.PageParameter.sellServiceCharge = sellServiceCharge
        this.trSearchInfo.PageParameter.offline_sellServiceCharge = offline_sellServiceCharge
        this.trSearchInfo.PageParameter.tgOffline_sellServiceCharge = tgOffline_sellServiceCharge
        this.trSearchInfo.PageParameter.slp_sellServiceCharge = slp_sellServiceCharge
      } catch (error) {
        throw error
      }
    },
    async handleGtParam() {
      await this.$store.dispatch('tr/getPageParameter').then(() => {
        const queryParam = localget("query_param");
        if (queryParam && "gt_123" == queryParam["app_from"]) {
          console.log("this.trSearchInfo111{}", this.trSearchInfo);

          const newSearchInfo = JSON.parse(JSON.stringify(this.trSearchInfo));
          newSearchInfo.fromStationCode = queryParam.from;
          newSearchInfo.toStationCode = queryParam.to;
          newSearchInfo.byTrainDate = queryParam.date;
          newSearchInfo.tripType = 1;

          this.$store.commit('tr/trSearchInfo', newSearchInfo);
          console.log("修改后的数据:", newSearchInfo, queryParam.from, queryParam.to, queryParam.date);
        }
      });

    },
    // 前一天
    prevDay() {
      try {
        this.dateInfo = TrainBookInteractor.getPrevDay(this.trSearchInfo.byTrainDate, this.trSearchInfo.MIN_DATE)
        this.trSearchInfo.byTrainDate = this.dateInfo.date
      } catch (error) {
        this.$toast(error)
      }
    },
    // 后一天
    afterDay() {
      try {
        this.dateInfo = TrainBookInteractor.getAfterDay(this.trSearchInfo.byTrainDate, this.trSearchInfo.MAX_DATE)
        this.trSearchInfo.byTrainDate = this.dateInfo.date
      } catch (error) {
        this.$toast(error)
      }
    },
    showDate(){
      if(this.serviceCtrl.isChangeDate){
        if(this.trSearchInfo.MIN_DATE&&this.trSearchInfo.MAX_DATE){
          this.$refs.date.toggle({
            defaultDate:this.trSearchInfo.byTrainDate,
            minDate:this.trSearchInfo.MIN_DATE,
            maxDate:this.trSearchInfo.MAX_DATE
          })
        }else{
          this.$refs.date.toggle({
            defaultDate:this.trSearchInfo.byTrainDate
          })
        }
      }
    },
    // 选择日期
    getDate(date) {
      this.dateInfo = formatDate(date)
      this.trSearchInfo.byTrainDate = date
    },
    closeTravelTips(){
      if(Object.keys(this.trainInfo).length){
        this.jump(this.trainInfo)
      }
    },
    // 选择车次
    selected(info) {
      // if(this.$refs.traveltips&&this.$refs.traveltips.isShowCallBack()){
      // this.trainInfo=info
      // 	this.cabinInfo=info
      // 	this.$refs.traveltips.toggle()
      // 	return
      // }
      this.jump(info)
    },
    jump(train){
      try {
        TrainBookInteractor.validTrain(train)
        this.toDetail(train)
      } catch (error) {
        if (error.type === 'confirm') {
          this.$dialog.confirm({
            message: error.errMessage
          }).then(() => {
            this.toDetail(train)
          })
        } else if (error.type === 'alert') {
          this.$dialog.alert({ message: error.errMessage })
        }
      }
    },
    toDetail(train) {
      this.trSearchInfo.TrainDetail = train
      // this.$router.push('/tr/trDetail')
      this.$router.push({
        path: "/tr/trDetail",
        query: {
          ccsqdId: this.$route.query.ccsqdId,
          routeId: this.$route.query.routeId
        }
      });
    },

  },
  watch: {
    'trSearchInfo.byTrainDate'() {
      if (this.$route.name === 'trList') this.getList()
    }
  },
  computed: {
    ...mapGetters({
      trSearchInfo: 'tr/trSearchInfo',
      serviceCtrl: 'serviceCtrl',
      loginConfig:'loginConfig'

    }),
    than15(){
      return formatDate(new Date().setDate( new Date().getDate() + 14)).date
    }
  }
}
</script>

<style lang="less">
</style>
